import { CoreBox, CoreTooltip, CoreTypography } from '@youscience/core';
import { UserCertificationProduct } from '@common-types';

import EarnedCertificationIcon from '@images/earned-certification.svg?react';
import NotEarnedCertificationIcon from '@images/not-earned-certification.svg?react';

import { sxStyles, StyledCardWrap } from './CertificationCard.styles';

export const EARNED_CERTIFICATION_TOOLTIP = 'You earned it!';
export const NOT_EARNED_CERTIFICATION_TOOLTIP = 'You haven’t earned it yet.';

interface CertificationCardProps {
  certification: UserCertificationProduct;
}

export const CertificationCard = (props: CertificationCardProps) => {
  const { productName, hasCertification } = props.certification;

  const iconTooltipText = hasCertification ? EARNED_CERTIFICATION_TOOLTIP : NOT_EARNED_CERTIFICATION_TOOLTIP;
  const icon = hasCertification ? (
    <EarnedCertificationIcon data-testid="earnedIcon" />
  ) : (
    <NotEarnedCertificationIcon data-testid="notEarnedIcon" />
  );

  return (
    <StyledCardWrap>
      <CoreTooltip data-testid="iconTooltip" title={iconTooltipText}>
        <CoreBox sx={sxStyles.icon}>{icon}</CoreBox>
      </CoreTooltip>

      <CoreTypography data-testid="productName" sx={sxStyles.title} variant="body2">
        {productName}
      </CoreTypography>
    </StyledCardWrap>
  );
};
